var map = {
	"./ad.svg": 99396,
	"./al.svg": 32780,
	"./at.svg": 27156,
	"./ba.svg": 40864,
	"./be.svg": 79308,
	"./bg.svg": 43694,
	"./by.svg": 42792,
	"./ch.svg": 49166,
	"./cz.svg": 33276,
	"./de.svg": 50146,
	"./dk.svg": 43620,
	"./ee.svg": 3329,
	"./es.svg": 5919,
	"./fi.svg": 23116,
	"./fr.svg": 88999,
	"./gb.svg": 39816,
	"./gr.svg": 45144,
	"./hr.svg": 26209,
	"./hu.svg": 66302,
	"./ie.svg": 36189,
	"./il.svg": 83764,
	"./it.svg": 88332,
	"./kz.svg": 56644,
	"./li.svg": 942,
	"./lt.svg": 15579,
	"./lu.svg": 46762,
	"./lv.svg": 96057,
	"./mc.svg": 80231,
	"./md.svg": 60424,
	"./me.svg": 84697,
	"./mk.svg": 69551,
	"./nl.svg": 31225,
	"./no.svg": 39850,
	"./pl.svg": 77023,
	"./pt.svg": 57991,
	"./ro.svg": 26038,
	"./rs.svg": 25858,
	"./ru.svg": 99692,
	"./se.svg": 67131,
	"./sk.svg": 93437,
	"./tr.svg": 45197,
	"./ua.svg": 97613
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4729;